export const normalizeNomeCompleto = (value?: string) =>
  (value ?? "").trim().replace(/\s+/g, " ");

export const hasNomeESobrenome = (value?: string) =>
  normalizeNomeCompleto(value).split(" ").filter(Boolean).length >= 2;
